import { createStore } from "vuex";

export default createStore({
  state: {
    // api: "http://192.168.1.178:8000/api",
    // server: "http://192.168.1.178:8000/",
    api:"https://backend.letmewaxyou.com/api",
    server:"https://backend.letmewaxyou.com/",
    ticketSelected: "",
    reservation: {
      name: "",
      prenom: "",
      email: "",
      place: 1,
      boissons: [],
      codepromo: "",
      tableId: "",
      ticket_id: "",
    },
    tables: [],
    boissons: [],
    data: "",
    total: 0,
    payement: false,
  },
  getters: {},
  mutations: {
    SetCurrentTicket(state, ticket) {
      state.ticketSelected = ticket;
    },
  },
  actions: {
    SETCURRENTTICKET({ commit }, ticket) {
      commit("SetCurrentTicket", ticket);
    },
  },
  modules: {},
});
